/**
 * The readable tail of a fully-qualified tag / datapoint id — everything after
 * the leading id segment. `longridge-01-PT-A` reads as `01-PT-A`; an id with no
 * separator is returned whole.
 *
 * Shared so the sentinel builder, list, and chart legend shorten ids the same
 * way. (The Experiment Lab keeps its own private `short` copies; those stay put
 * under the do-not-touch rule.)
 */
export const shortTagId = (id: string): string =>
  id.split('-').slice(1).join('-') || id
